import React, { Fragment, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const MyCartSideSkeleton = ({ count }) => {
  const [noOfRows, setNoOfRows] = useState(1);

  useEffect(() => {
    if (count && Number.isInteger(count)) {
      setNoOfRows(Math.max(count, 1));
    }
  }, [count]);
  return (
    <Fragment>
      <div className="offcanvas-body cartPopup-body">
        <div className="cartPoup-info" style={{ padding: "10px" }}>
          <h6>
            <Skeleton width={100} height={20} />
          </h6>
          <p>
            <Skeleton width={60} height={15} />
          </p>
        </div>
        <div className="added-cartPopup">
          {noOfRows &&
            Array.from({ length: noOfRows }).map((_, index) => (
              <div className="added-cartPro" key={index}>
                <div
                  className="added-cartPro-img"
                  style={{ height: "95px", lineHeight: "unset" }}
                >
                  <Skeleton height={80} width={80} />
                </div>
                <div className="added-cartPro-content">
                  <div className="added-cartPro-info">
                    <div className="added-cartPro-item">
                      <h6>
                        <Skeleton width={150} />
                      </h6>

                      <p>
                        <Skeleton width={100} />
                      </p>
                    </div>
                    <div className="border-link">
                      <Skeleton circle height={30} width={30} />
                    </div>
                  </div>
                  <div className="added-cartPro-price">
                    <p>
                      <Skeleton width={50} />
                    </p>
                    <div className="product-quantity">
                      <div className="qty-container">
                        <Skeleton circle height={30} width={30} />
                        <Skeleton
                          height={30}
                          width={50}
                          style={{ margin: "0 5px" }}
                        />
                        <Skeleton circle height={30} width={30} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};
